import { Route, Routes } from 'react-router-dom';
// import AppRoutes from './AppRoutes';
// import AppAdminRoute from './AppAdminRoute';

import { Layout } from './components/Layout';
import { Home } from "./components/Home";

import { TableLayout } from "./components/TableLayout";
import { ClientFormTable } from './components/Cilent/ClientForm/ClientFormTatble';
import { Casting } from './components/Casting/Casting'

import { AdminLayout } from './components/AdminLayout';
import { AdminHome } from "./components/Admin/AdminHome";

import './custom.css';
import { UserLogin } from './components/Admin/users/UserLogin';
import { Users } from './components/Admin/users/Users';
import { UserDetails } from './components/Admin/users/UserDetails';
import UserEdit from './components/Admin/users/UserEdit';
import UserChangePassword from './components/Admin/users/UserChangePassword';
import { Logout } from './features/Logout';
import TestLoginForm from './components/Admin/users/TestLoginForm';
import useToken from './components/useToken'
import LoadScreen from './components/UI/LoadScreen';
import { Certificate } from './components/Certificate/Certificate';
import { CerteficateAdmin } from './components/Certificate/Admin/CerteficateAdmin';
import { CerteficateDetails } from './components/Certificate/Admin/CerteficateDetails';
import { Orders } from './components/Orders/Orders';
import { Categories } from './components/Products/Categories/Categories';
import { CategoriesEdit } from './components/Products/Categories/CategoriesEdit';
import { Agents } from './components/Products/Agents/Agents';
import { AgentsEdit } from './components/Products/Agents/AgentsEdit';
import { Products } from './components/Products/Products';
import { ProductEdit } from './components/Products/ProductEdit'
import { ProductDetails } from './components/Products/ProductDetails';
import { ProductCatalog } from './components/Orders/ProductCatalog';
import { OrderDetails } from './components/Orders/OrderDetails';
import { Clients } from './components/Cilent/Clients';
import { ClientDetails } from './components/Cilent/ClientDetails';
import { ClientEdit } from './components/Cilent/ClientEdit';
import { TestSignalR } from './components/SessionEvent/TestSignalR';
import { SessionEvent } from './components/SessionEvent/SessionEvent';
import { SessionEventDetails } from './components/SessionEvent/SessionEventDetails';
import { EventList } from './components/SessionEvent/EventList';
import { QueueScreen } from './components/SessionEvent/QueueScreen';
import { FullScreenLayout } from './components/FullScreenLayout';
import { ReportsIgora } from './components/Reports/ReportsIgora';
import { QueueScreenOutLogo } from './components/SessionEvent/QueueScreenOutLogo';
import { Requests } from './components/Requests/Requests';
import { Scanner } from './components/Admin/Scanner';
import { QrCodeList } from './components/QrCodeList';
import { RoportsNikolas } from './components/Reports/RoportsNikolas';
import { Tickets } from './components/Tickets/Tickets';
import { TicketsOrderDetails } from './components/Tickets/TicketsOrderDetails';
import { ReportsInternetOrders } from './components/Reports/ReportsInternetOrders';

export const App = () => {
  const { token, setTokenData, loadingSite, role, getRefreshToken, fullName } = useToken();

  if (loadingSite) {
    return (
      <LoadScreen />
    );
  }
  return (
    <>
      <Routes>
        <Route path='/admin' element={<AdminLayout token={token} role={role} getRefreshToken={getRefreshToken} />}>
          <Route index element={<AdminHome fullName={fullName} />} />
          <Route path='users' element={<Users />} />
          <Route path='users/details/:id' element={<UserDetails />} />
          <Route path='users/edit/:id' element={<UserEdit />} />
          <Route path='users/changepassword/:id' element={<UserChangePassword />} />
          <Route path='orders' element={<Orders />} />
          <Route path='orders/details/:id' element={<OrderDetails />} />
          <Route path='orders/certeficate' element={<CerteficateAdmin />} />
          <Route path='orders/certeficate/details/:id' element={<CerteficateDetails />} />
          <Route path='categories' element={<Categories />} />
          <Route path='categories/edit/:id' element={<CategoriesEdit />} />
          <Route path='agents' element={<Agents />} />
          <Route path='agents/edit/:id' element={<AgentsEdit />} />
          <Route path='products' element={<Products />} />
          <Route path='products/edit/:id' element={<ProductEdit />} />
          <Route path='products/details/:id' element={<ProductDetails />} />
          <Route path='catalog' element={<ProductCatalog />} />
          <Route path='clients' element={<Clients />} />
          <Route path='clients/details/:id' element={<ClientDetails />} />
          <Route path='clients/edit/:id' element={<ClientEdit />} />
          <Route path='signalr' element={<TestSignalR />} />
          <Route path='sessionevents' element={<SessionEvent role={role} />} />
          <Route path='sessionevents/details/:id' element={<SessionEventDetails token={token} />} />
          <Route path='sessionevents/list/:id' element={<EventList />} />
          <Route path='reports/igora' element={<ReportsIgora />} />
          <Route path='reports/ticketssite' element={<RoportsNikolas />} />
          <Route path='reports/internet-orders' element={<ReportsInternetOrders />} />
          <Route path='scanner' element={<Scanner />} />
          {/* <Route path='sessionevents' element={""} /> */}
          <Route path='ticketslc' element={<Tickets />} />
          <Route path='ticketslc/details/:id' element={<TicketsOrderDetails role={role} />} />
        </Route>
        <Route path='/admin' element={<FullScreenLayout />}>
          <Route path='sessionevents/queuescreen/:id' element={<QueueScreen />} />
          <Route path='sessionevents/queuescreennologo/:id' element={<QueueScreenOutLogo />} />
        </Route>
        <Route path='/' element={<Layout token={token} />}>
          <Route index element={<Home />} />
          <Route path='certificate' element={<Certificate />} />
          <Route path='logout' element={<Logout />} />
          <Route path='login' element={<UserLogin setTokenData={setTokenData} />} />
          <Route path='loginTest' element={<TestLoginForm />} />
          <Route path='requests' element={<Requests />} />
          <Route path='qrcode/:id' element={<QrCodeList token={token} />} />
          <Route path="*" element={<Home />} />
        </Route>
        <Route path='/table' element={<TableLayout />}>
          <Route index element={<ClientFormTable />} />
          {/* <Route path='casting' element={<Casting />} /> */}
        </Route>
      </Routes>
    </>


  );
}

export default App;
